/* tslint:disable */
/* eslint-disable */
/**
 * RakuLogi API
 * RakuLogi の API ドキュメント
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RequestApproveUserRequest
 */
export interface RequestApproveUserRequest {
    /**
     * 
     * @type {number}
     * @memberof RequestApproveUserRequest
     */
    baseId?: number;
    /**
     * 
     * @type {number}
     * @memberof RequestApproveUserRequest
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof RequestApproveUserRequest
     */
    tenantId?: number;
    /**
     * 
     * @type {number}
     * @memberof RequestApproveUserRequest
     */
    updatedUserId?: number;
}

/**
 * Check if a given object implements the RequestApproveUserRequest interface.
 */
export function instanceOfRequestApproveUserRequest(value: object): value is RequestApproveUserRequest {
    return true;
}

export function RequestApproveUserRequestFromJSON(json: any): RequestApproveUserRequest {
    return RequestApproveUserRequestFromJSONTyped(json, false);
}

export function RequestApproveUserRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RequestApproveUserRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'baseId': json['base_id'] == null ? undefined : json['base_id'],
        'id': json['id'] == null ? undefined : json['id'],
        'tenantId': json['tenant_id'] == null ? undefined : json['tenant_id'],
        'updatedUserId': json['updated_user_id'] == null ? undefined : json['updated_user_id'],
    };
}

export function RequestApproveUserRequestToJSON(json: any): RequestApproveUserRequest {
    return RequestApproveUserRequestToJSONTyped(json, false);
}

export function RequestApproveUserRequestToJSONTyped(value?: RequestApproveUserRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'base_id': value['baseId'],
        'id': value['id'],
        'tenant_id': value['tenantId'],
        'updated_user_id': value['updatedUserId'],
    };
}

